import { storageService } from "./storageService";

export const APP_VERSION: string = __APP_VERSION__;

export function shouldShowReleaseNotice(): boolean {
  return storageService.getVersion<string>() !== APP_VERSION;
}

export function markReleaseNoticeSeen(): void {
  storageService.setVersion(APP_VERSION);
}